/**
 * Route for `fraud-tool-access-permission-per-role`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FraudToolAccessPermissionPerRolePage } from "../features/fraud-tool-access-permission-per-role/FraudToolAccessPermissionPerRolePage";

export const fraudToolAccessPermissionPerRoleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fraud-tool-access-permission-per-role",
	component: FraudToolAccessPermissionPerRolePage,
});

export default fraudToolAccessPermissionPerRoleRoute;
